import { Component, EventEmitter, Input, Output } from '@angular/core';
import moment from 'moment';

import { PatientListService } from '../../patient-list.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[msd-patient-cell]',
  templateUrl: './patient-cell.component.html',
  styleUrls: ['./patient-cell.component.scss'],
})
export class PatientCellComponent {
  @Input() title: string;
  @Input() initials?: string | undefined;
  @Input() avatarUrl?: string | undefined;
  @Input() sort: 'createdAt' | 'updatedAt' | 'lastActiveDate' | undefined;
  @Input() lastSeen?: moment.Moment;
  @Input() updateAt?: moment.Moment;
  @Input() createAt?: moment.Moment;
  @Input() appInstalled = false;
  @Input() archivedAt?: Date | undefined;
  @Input() isActionLoading: boolean;
  @Input() withActionButton = true;
  @Input() groups: string[] | undefined;
  @Input() displayGroups = true;
  @Input() checkable = false;
  @Input() checked: boolean;
  @Input() checkAll = false;
  @Output() onClick = new EventEmitter<void>();
  // dropdown actions
  @Output() onEncouragement = new EventEmitter();
  @Output() onSendDocument = new EventEmitter();
  @Output() onAddToGroup = new EventEmitter();
  @Output() onRemoveToGroup = new EventEmitter();
  @Output() onSendMessage = new EventEmitter();
  @Output() onSendQuiz = new EventEmitter();
  @Output() onArchive = new EventEmitter();
  @Output() onActivate = new EventEmitter();
  @Output() checkedChange = new EventEmitter<boolean>();

  constructor(private patientListService: PatientListService) {
    // Nada
  }

  onCheckedChange(value: boolean) {
    this.checkedChange.emit(value);
    this.patientListService.indeterminate.next();
  }

  public removeToGroup() {
    if (this.groups && this.groups.length > 0) {
      this.onRemoveToGroup.emit();
    }
  }

  public getDate(): string {
    if (this.sort) {
      if (this.sort === 'lastActiveDate') {
        return this.lastSeen
          ? 'Le ' + this.lastSeen.format('DD.MM.yyyy')
          : '--';
      } else if (this.sort === 'createdAt') {
        return this.createAt
          ? 'Le ' + this.createAt.format('DD.MM.yyyy')
          : '--';
      }
    }
    return this.updateAt ? 'Le ' + this.updateAt.format('DD.MM.yyyy') : '--';
  }

  public offsetDropdown(bAct: HTMLButtonElement, height: number): boolean {
    const pos = bAct.getBoundingClientRect();
    return window.innerHeight - (pos.top + window.scrollY) - height < 0;
  }
}
